import cms from '../content/pax/1.10.0/data.json';
import { initializeTranslations } from '../store/i18n';
import { fetchProducts } from '../store/products';
import { initABTesting } from '../utils/ab/remoteABTest';
import { setABTests, setPlanner, setStoreId } from './app';
import { getProductFields } from './products/productFields';
import { store } from './store';
/**
 * Receives the translations and dispatches to the store.
 */
export async function initializeAppTranslations(translations) {
    store.dispatch(initializeTranslations(translations));
}
/**
 * Fetches the corresponding data and dispatches to the store.
 */
export async function initializePlanner(planner, insightsApi, countryCode, isKiosk, presetStoreId, ab) {
    try {
        const localizedCms = localizeCms(countryCode, cms);
        store.dispatch(setPlanner({ planner, cms: localizedCms }));
        if (presetStoreId) {
            store.dispatch(setStoreId(presetStoreId));
        }
        const abTest = await initABTesting(insightsApi, isKiosk, ab);
        store.dispatch(setABTests(abTest));
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
}
/**
 * A @async function that takes one parameter.
 * Fetches the corresponding data and dispatches to the store.
 *
 * @param productService
 */
export async function initializeProducts(productService) {
    try {
        const optionalParams = {
            valid: true
        };
        const products = await productService.getApplicationProducts(getProductFields(), optionalParams);
        store.dispatch(fetchProducts(products));
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
}
const CHILE = 'CL';
const JAPAN = 'JP';
const SOUTH_KOREA = 'KR';
const COLOMBIA = 'CO';
/**
 * Removes the 236 cm height option from the cms form data
 */
const no236cmHeightRule = [
    [CHILE, JAPAN, SOUTH_KOREA, COLOMBIA],
    cms => {
        return {
            ...cms,
            form: cms.form.map(formItem => formItem.id === 'size_height'
                ? {
                    ...formItem,
                    options: formItem.options.filter((option) => option.id !== 'height_236')
                }
                : formItem)
        };
    }
];
const localizationPatches = [no236cmHeightRule];
/**
 * Temporary fix for handling market specific logic of the cms data
 * @param countryCode
 * @param cms
 */
const localizeCms = (countryCode, cms) => {
    return localizationPatches.reduce((cms, [countries, patch]) => (countries.includes(countryCode.toUpperCase()) ? patch(cms) : cms), cms);
};
//# sourceMappingURL=initialize.js.map